export default __webpack_public_path__ + "static/media/paymentWhite.d7706dcb.svg";